module.exports = __webpack_public_path__ + "static/media/mass-frame-4.efc502ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/screens/highDefinitionOptics/MassTest/mass-frame-4.jpg
// module id = 3633
// module chunks = 0